import { useEffect, useState } from "react";
import Table, { Column } from "../../../Components/Tables/Table";
import PageHeader from "../../../Layout/PageHeader";
import historyIcon from "../../../assets/images/history-icon.svg";
import { useParams } from "react-router-dom";
import DynamicDetailGrid from "../../../Components/Grid/DynamicDetailGrid";
import { HistoryLaoutDataCheckInDetail } from "../../../Data/testData";
import HistoryLayout from "../../../Layout/HistoryLaout";
import {
  readyToPackDetailData,
  readyToPickDetailData,
} from "../../../Data/outbound";
import AssignToUserLayout from "../../../Layout/AssignToUserLayout";
import warningIcon from "../../../assets/images/warning.svg";
import CommonModal from "../../../Components/Modals/CommonModal";
import PickedLayout from "../../../Layout/PickedLayout";

export default function PackDetails() {
  const { id } = useParams<{ id: string }>();
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(!show);
  const [isShowCanvas, setShowCanvas] = useState(false);
  const pageName = `Pack (${id})`;

  useEffect(() => {}, []);

  const handelCanvas = () => {
    setShowCanvas(!isShowCanvas);
  };
  const [showRecountModal, setShowRecountModal] = useState(false);

  const handleWarningClick = () => {
    setShowRecountModal(true);
  };

  const closeRecountModal = () => {
    setShowRecountModal(false);
  };
  const historyData = (
    <>
      <div
        className="d-flex justify-content-between w-100 align-items-center px-4"
        onClick={handelCanvas}
      >
        <div>
          <h6 className="cursor-pointer m-0 d-flex align-items-center">
            <img src={historyIcon} className="me-2" />
            History
          </h6>
        </div>
      </div>
    </>
  );
  const readyToPackDetails = [
    {
      label: "Order #",
      value: (
        <>
          <div className="w-fit">0R-663006</div>
        </>
      ),
    },
    {
      label: "Shipment #",
      value: "SH-8574123",
    },
    { label: "Releases", value: 254894 },
    { label: "Pick Ticket #", value: "PT-874601" },
    { label: "Bill-To Code", value: "CS-478" },
    { label: "Pack Qty", value: "25" },
    { label: "No. Of Pallets", value: "-" },
    { label: "No. of Loose Boxes", value: "-" },
    { label: "Pack Method", value: "Pack With Audit" },
    { label: "Ship To", value: "Kavien" },
    { label: "Shipment Qty", value: "25" },
    { label: "Picked Qty", value: "25" },
    { label: "In Packing Qty", value: "25" },
    { label: "Drop Location", value: "-" },
    { label: "Pack Area", value: "Zone 2" },

    {
      label: "Status",
      value: (
        <>
          <div className=" asn-overview-status-border-purple rounded px-4 fs-11 w-auto d-inline-block">
            Ready To Pack
          </div>
        </>
      ),
    },

    { label: "Notes", value: "-" },
    {
      label: "Special Instructions",
      value: (
        <>
          <div>
            Handle with care dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the (
            <span className="cursor-pointer text-primary">View More</span>)
          </div>
        </>
      ),
    },
  ];
  const columns: Column[] = [
    {
      name: "Shipment Line",
      selector: (row: { shipmentLine: string }) => row.shipmentLine,
    },
    {
      name: "Pick Ticket #",
      selector: (row: { pickTicket: string }) => row.pickTicket,
    },
    {
      name: "No. of Picks",
      selector: (row: { noOfPicks: string }) => row.noOfPicks,
    },
    {
      name: "Total Qty",
      selector: (row: { totalQty: string }) => row.totalQty,
    },
    {
      name: "Picked Qty",
      selector: (row: { pickedQty: string }) => row.pickedQty,
    },
    {
      name: "Pick Method",
      selector: (row: { pickMethod: string }) => row.pickMethod,
    },
    {
      name: "Assigned to",
      selector: (row: { assignedTo: string }) => row.assignedTo,
    },
    {
      name: "Detail",
      selector: (row: { detail: string }) => row.detail,
    },
  ];

  const handelAssignAction = () => {
    setShow(true);
  };

  return (
    <>
      <PageHeader
        listUrl="/outbound/pack/overview"
        viewType={true}
        isHistoryEnabled={true}
        historyData={[historyData]}
        isModal={true}
        name="ASSIGN"
        heading="Assign To"
        content={<AssignToUserLayout handleClose={() => setShow(false)} />}
        modalSize="modal-md"
        customBtn={handelAssignAction}
        isCustomBtn={true}
      />

      <h5 className="text-start mt-1 mb-3">{pageName}</h5>
      <div className="my-2 bg-white rounded py-1 px-2 d-flex flex-column">
        <div className="shipments-details col-12 bg-white col-12 py-1  px-2 ">
          <div className="shipments-details flex-column-reverse align-items-center d-flex bg-white ">
            <div className="d-flex col-12 py-4">
              <div className="d-flex col">
                <DynamicDetailGrid
                  customClassName="mb-2 pt-0 col"
                  isExpandable={false}
                  columns={3}
                  data={readyToPackDetails}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="my-2 bg-white rounded py-1 px-2 detail-table-scroll">
        <Table
          columns={columns}
          data={readyToPackDetailData}
          CheckboxStatus={false}
          isStripped={true}
          customClassName="transferDetailsTable"
        />
      </div>
      <HistoryLayout
        isShowCanvas={isShowCanvas}
        showViewScanLogs={true}
        handelCanvas={handelCanvas}
        data={HistoryLaoutDataCheckInDetail}
      />
      <CommonModal
        handleClose={closeRecountModal}
        show={showRecountModal}
        content={<PickedLayout handleClose={closeRecountModal} />}
        modalSize="modal-md"
      />
      <CommonModal
        handleClose={() => setShow(false)}
        show={show}
        heading="Assign To"
        content={<AssignToUserLayout handleClose={() => setShow(false)} />}
        modalSize="modal-lg"
        footerButtonsActive={false}
      />
    </>
  );
}
